import { render, staticRenderFns } from "./DashboardMasterInstituciones.vue?vue&type=template&id=089405d0"
import script from "./DashboardMasterInstituciones.vue?vue&type=script&lang=js"
export * from "./DashboardMasterInstituciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports